// Session storage utilities for tracking user notifications and states

const GYM_NOTIFICATION_KEY = "gymNotificationShown";

export const hasShownGymNotification = (): boolean => {
  return sessionStorage.getItem(GYM_NOTIFICATION_KEY) === "true";
};

export const markGymNotificationShown = (): void => {
  sessionStorage.setItem(GYM_NOTIFICATION_KEY, "true");
};

export const clearGymNotificationFlag = (): void => {
  sessionStorage.removeItem(GYM_NOTIFICATION_KEY);
};
